package ai.jessie.web.work

import ai.jessie.shared.work.WorkCalendarResponse
import ai.jessie.shared.work.WorkCalendarView
import androidx.compose.runtime.staticCompositionLocalOf

// UC-009. An absent view or date lets the server choose the current organisation-local week.
interface WorkCalendarPort {
    suspend fun calendar(
        organisationId: String,
        view: WorkCalendarView?,
        date: String?,
    ): WorkCalendarResponse
}

val LocalWorkCalendarPort =
    staticCompositionLocalOf<WorkCalendarPort> {
        error("Work calendar port must be supplied by the application")
    }

// Syntax only; the server decides whether the date exists and resolves its range.
fun validCalendarDate(value: String) = value.matches(Regex("\\d{4}-\\d{2}-\\d{2}"))

fun calendarView(value: String?) = WorkCalendarView.entries.firstOrNull { it.name == value }
